import React, { useState } from "react";
import Footer from "../components/Shared/Footer";

const Press = () => {

  return (
    <div>

      <section className="breadcrumb-section pt-0">
      <div className="container-fluid-lg">
          <div className="row">
              <div className="col-12">
                  <div className="breadcrumb-contain">
                      <h2>Press</h2>
                      <nav>
                          <ol className="breadcrumb mb-0">
                              <li className="breadcrumb-item">
                                  <a href="/">
                                      <i className="fa-solid fa-house"></i>
                                  </a>
                              </li>
                              <li className="breadcrumb-item active">Press</li>
                          </ol>
                      </nav>
                  </div>
              </div>
          </div>
      </div>
      </section>
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12 col-md-6">
                <div className="card">
                    <div className="card-body">
                    <h2 className="font-lg mb-3">
                            <a href="https://timesofindia.indiatimes.com/city/chennai/white-paper-released-on-diabetes-care-101-million-indians-diagnosed/articleshow/119353071.cms" 
                               target="_blank" 
                               rel="noopener noreferrer"
                               className="text-decoration-none">
                                <h2 className="justify_content">
                                White paper released on diabetes care, 101 million Indians diagnosed
                                </h2>
                            </a>
                        </h2>
                        <p className="card-text text-muted font-xsm justify_content">
                        CHENNAI: Lack of awareness and inadequate foot care contribute significantly to amputations among people with diabetes in low and middle-income countries, said Dr Frances Game, clinical director of R&D at University Hospitals of Derby and Burton, NHS Foundation Trust, England.
                        </p>
                    </div>
                </div>
            </div>
            
          </div>
        </div>

      </section>

      <div>
          <Footer />
      </div>
    </div>
  );
};

export default Press;
